import { useQuery } from '@tanstack/react-query';
import { companyService } from '@/api/services/CompanyService';
import { useAuth } from '@/stores/authContext';

export const BANK_DETAILS_QUERY_KEY = ['bankDetails'] as const;

// Банковские счёта организации (server-state). Включены только при авторизации.
export function useBankDetails() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: BANK_DETAILS_QUERY_KEY,
    queryFn: () => companyService.listBankDetails(),
    enabled: isAuthenticated,
    staleTime: 5 * 60_000,
  });
}
